export default function MyFooter() {
  return (
    <div id="/end">
      {/*<OverPack playScale={0.2}>*/}
      {/*  <QueueAnim*/}
      {/*    className="home-foot"*/}
      {/*    type="bottom"*/}
      {/*    leaveReverse*/}
      {/*    key="home-foot-qa-1"*/}
      {/*  >*/}
      {/*    <div className="home-foot-box" key="home-foot-box-1">*/}
      {/*      <h2>联系我们</h2>*/}
      {/*      <span>info@morningalliance.cn</span>*/}
      {/*      <span>上海市黄浦区淮海中路333号瑞安广场1705室</span>*/}
      {/*    </div>*/}
      {/*    /!*<div className="home-foot-box" key="home-foot-box-2">*!/*/}
      {/*    /!*  <h2>关于我们</h2>*!/*/}
      {/*    /!*</div>*!/*/}
      {/*  </QueueAnim>*/}
      {/*</OverPack>*/}
      <div className="home-foot-beian">
        <span className="home-foot-p">
          ©{new Date().getFullYear()} 上海晨联投资管理有限公司 版权所有
        </span>
        <a
          className="home-foot-a"
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noreferrer noopener"
        >
          沪ICP备2025113876号
        </a>
      </div>
    </div>
  );
}